import React from 'react';

import DatabaseLogApi from '../../../Api/CRM/Modules/DatabaseLogApi';
import UserLogin from '../../../Api/Models/UserLogin';
import { formatDateStringWithTimezone } from '../../../utils/formatters';
import Search from '../../elements/Search';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function UserLoginLogs({ userId }: { userId: number }) {
    const { items, isLoading, auto } = useAutoPaginator<UserLogin>((page, params) => {
        return DatabaseLogApi.getUserLogins(userId, page, { params });
    });

    return (
        <Card title="User login logs">
            <Search {...auto.search} />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Time</th>
                        <th>IP address</th>
                        <th>User agent</th>
                    </TableHead>
                    <tbody>
                        {items.map((login) => (
                            <tr key={login.id}>
                                <td>{formatDateStringWithTimezone(login.created_at)}</td>
                                <td>{login.ip_address}</td>
                                <td>{login.user_agent}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default UserLoginLogs;
